var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Smoking = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19,14 C19.5522847,14 20,14.4477153 20,15 L20,17 C20,17.5522847 19.5522847,18 19,18 L4,18 L4,14 L19,14 Z M15,15 L5,15 L5,17 L15,17 L15,15 Z M19,15 L18,15 L18,17 L19,17 L19,15 Z M17,15 L16,15 L16,17 L17,17 L17,15 Z M18.5,4 C18.7761424,4 19,4.22385763 19,4.5 C19,4.77614237 18.7761424,5 18.5,5 C17.2858863,5 16.0792586,5.96820925 15.9992363,7.41435918 C15.9415325,8.45717174 16.4213437,9.22608108 17.5092151,9.78016441 L17.7075188,9.87572582 L18,10.0091509 L18,12.5 C18,12.7761424 17.7761424,13 17.5,13 C17.2545401,13 17.0503916,12.8231248 17.0080557,12.5898756 L17,12.5 L16.999,10.641 L16.8799383,10.5774174 C15.6362251,9.88398861 14.9897938,8.86529237 14.9945345,7.56650218 L15.0007637,7.35910898 C15.1122676,5.344029 16.7872596,4 18.5,4 Z M18.6294216,7.01137281 C19.9958706,7.01137281 21,8.16114752 21,9.5 C21,10.2043176 20.7053959,10.8374775 20.1417964,11.3851835 L20,11.515 L20,12.5 C20,12.7454599 19.8231248,12.9496084 19.5898756,12.9919443 L19.5,13 C19.2545401,13 19.0503916,12.8231248 19.0080557,12.5898756 L19,12.5 L19,11.0375381 L19.1921449,10.8873989 C19.7448052,10.4555583 20,10.000958 20,9.5 C20,8.68558077 19.4111959,8.01137281 18.6294216,8.01137281 C18.3532792,8.01137281 18.1294216,7.78751518 18.1294216,7.51137281 C18.1294216,7.23523043 18.3532792,7.01137281 18.6294216,7.01137281 Z" })));
};
Smoking.displayName = 'Smoking';
export default Smoking;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Smoking.js.map